import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { I2079Form } from 'clickNgo/models/crud/forms'
import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

import { mapEngagementPrediction } from '../lib/mapEngagementPrediction'
import { EngagementPrediction } from '../model/types'

export const fetchEngagementPredictionByPartnerId = async (
  partnerId: string,
  options?: ICrudFetchOptions
): Promise<EngagementPrediction | null> => {
  const source = CrudStore.get<I2079Form>(
    CrudStoreItem.EngagementPrediction,
    options?.cacheKey || partnerId
  )

  source.setFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'PID',
        operator: Operator.EQUAL,
        value: partnerId,
      },
    ],
  })

  try {
    const response = await source.fetch({
      skipHierarchyFilter: options?.skipHierarchyFilter,
      force: options?.isForce,
      skipTotal: options?.skipTotal,
    })

    if (response && response.items && response.items.length > 0) {
      return mapEngagementPrediction(response.items[0])
    }

    return null
  } catch (error) {
    Logger.error('Error fetching Engagement Prediction:', error)

    throw error
  }
}
